import { CompetenzaParcella } from '../competenza-parcella';
import { TipoFase } from './tipo-fase';

export class FaseFascicolo {
  id: string;
  rimosso: boolean;
  descrizione: string;
  label: string;
  competenza: CompetenzaParcella ;
  tipoFase: TipoFase;
}
